export type MetadataValueType = 'boolean' | 'string' | 'integer' | 'float' | 'number' | 'aggregation' | 'list' | 'date';

export enum EventKind {
    Page = 'Page',
    Feature = 'Feature',
    TrackEvent = 'TrackType',
    Guide = 'Guide',
    App = 'App',
    AIAgent = 'AiAgent',
}

export const PageParameterRuleValue = '*parameter*';

export enum EventName {
    Page = 'pageViews',
    Feature = 'featureClicks',
    TrackEvent = 'trackEvents',
    Guide = 'guideViews',
    App = 'anyActivity',
    AIAgent = 'aiAgentInteractions',
}

export enum TimeInterval {
    Hour = 'hour',
    Day = 'day',
    Week = 'week',
    Month = 'month',
}

// This is already defined in Aggs Library, will need to refactor this
export enum TimeSeriesPeriod {
    Hourly = 'hourly',
    HourlyRange = 'hourRange',
    Daily = 'daily',
    DailyRange = 'dayRange',
    Weekly = 'weekly',
    WeeklyRange = 'weekRange',
    Monthly = 'monthly',
    MonthlyRange = 'monthRange',
}

export enum DateConfigTypes {
    Today = 'Today',
    Yesterday = 'Yesterday',
    Last7Days = 'Last 7 Days',
    Last30Days = 'Last 30 Days',
    Last90Days = 'Last 90 Days',
    Last180Days = 'Last 180 Days',
    Custom = 'Custom',
}

/**
 * For the moment, this uses the labels from the event-property-filter/utils.js
 * file. That decision is subject to change.
 */
export enum FilterOperator {
    True = 'is true',
    False = 'is false',
    Equal = '=',
    NotEqual = '!=',
    LessOrEqual = '<=',
    GreaterOrEqual = '>=',
    Contains = '~',
    NotContains = '!~',
    Empty = '()',
    NotEmpty = '(x)',
}

export enum FilterType {
    Device = 'device',
    Custom = 'custom',
    HistoricalMetadata = 'historicalMetadata',
    Utm = 'utm',
    Visitor = 'visitor',
    Account = 'account',
    ParentAccount = 'parentAccount',
    EventTopLevel = 'eventTopLevel',
    Location = 'location',
    PageParameter = 'parameter',
}

export enum MetadataTypeId {
    Automatic = 'automatic',
    Visitor = 'visitor',
    Account = 'account',
    ParentAccount = 'parentAccount',
    Historical = 'historical',
    Event = 'event',
    Utm = 'utm',
    PageParameter = 'pageParameter',
    EventTopLevel = 'eventTopLevel',
}

export const metadataTypeByFilterType = {
    [FilterType.Device]: MetadataTypeId.Automatic,
    [FilterType.Custom]: MetadataTypeId.Event,
    [FilterType.HistoricalMetadata]: MetadataTypeId.Historical,
    [FilterType.Visitor]: MetadataTypeId.Visitor,
    [FilterType.Account]: MetadataTypeId.Account,
    [FilterType.ParentAccount]: MetadataTypeId.ParentAccount,
    [FilterType.Utm]: MetadataTypeId.Utm,
    [FilterType.EventTopLevel]: MetadataTypeId.EventTopLevel,
    [FilterType.Location]: MetadataTypeId.EventTopLevel,
    [FilterType.PageParameter]: MetadataTypeId.PageParameter,
};

export interface MetadataValue {
    Type: MetadataValueType;
    DisplayName: string;
    ElementType?: string;
    ElementFormat?: string;
    Dirty?: boolean;
    isHidden?: boolean;
    isDeleted?: boolean;
    isCalculated?: boolean;
    isPerApp?: boolean;
    neverIndex?: boolean;
    isPromoted?: boolean;
    group?: string;
    field: string;
    kind: MetadataTypeId;
    sortable?: boolean;
    label?: string;
    prop?: string;
    isUtm?: boolean;
    id?: string;
    name?: string;
    selectionState?: string;
    isDisabled?: boolean;
    sample?: string | boolean | number;
    cardinality?: number;
    uniqueValues?: Array<string> | Array<number> | Array<Array<string>>;
}

export enum Icons {
    Page = 'file',
    Feature = 'feature',
    TrackType = 'zap',
    Path = 'map',
    Funnel = 'filter',
    AgentAnalytics = 'activity',
    DataExplorer = 'chart-area',
    Retention = 'retention-1',
    Workflow = 'workflows',
    Guide = 'guide',
    AIAgent = 'agentic',
    Visitor = 'user',
    Account = 'building-1',
}
